// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useModalContext } from 'components'
import ModalContainer from '../ModalContainer'
import { getInitialCommentValues } from '../helpers'

const modalConfig = {
  styles: {
    content: {
      width: 640,
    },
  },
}

const useShowNewCommentModal = ({ createCallback, idRoot, pathComment }) => {
  const dispatch = useDispatch()

  const { openContextModal } = useModalContext()

  return useCallback(() => {
    const initialValues = dispatch(getInitialCommentValues())

    openContextModal(
      <ModalContainer
        createCallback={createCallback}
        idRoot={idRoot}
        initialValues={initialValues}
        pathComment={pathComment} />,
      modalConfig
    )
  }, [createCallback, idRoot])
}

export default useShowNewCommentModal
